import { render, staticRenderFns } from "./stripes.vue?vue&type=template&id=716b2b24&scoped=true&"
import script from "./stripes.vue?vue&type=script&lang=ts&"
export * from "./stripes.vue?vue&type=script&lang=ts&"
import style0 from "./stripes.vue?vue&type=style&index=0&id=716b2b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716b2b24",
  null
  
)

export default component.exports